// @ts-ignore
/* eslint-disable */
import { request } from "@umijs/max";

/** 20201-查询启用的banner GET /app/v1/banner/list */
export async function appGetSwimEnableBannerList(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.appGetSwimEnableBannerListParams,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOListSwimBannerBasicVo>("/app/v1/banner/list", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
